import { useRouter } from 'next/router'
import React from 'react'
import Button from '#/components/Button'
import Link from '#/components/Link'
import OverlaySpinner from '#/components/OverlaySpinner'
import { logEvent } from '#/services/analytics'
import { SendResume } from '#/store/actions/user'
import styles from '../post-body.module.css'

interface PostBodyProps {
  asyncStatus?: TopHap.GlobalState['status']
  content: string
}

function logApplyClick(position: string) {
  logEvent('select_content', {
    content_type: 'careers',
    item_id: 'apply',
    location: `${position}`
  })
}

const PostBody: React.FC<PostBodyProps> = ({ asyncStatus, content }) => {
  const router = useRouter()

  return (
    <div className='mx-auto max-w-5xl'>
      <div className='flex space-x-8'>
        <div className='prose w-full'>
          <div
            dangerouslySetInnerHTML={{ __html: content }}
            className={styles.content}
          />
          <div className='b relative flex items-center justify-between border-opacity-75 pt-12 xs:mt-8 sm:pb-4 sm:pt-8 '>
            <Link
              href={`${router.asPath}/apply`}
              onClick={() => logApplyClick('body')}
            >
              <Button
                className='inline-block cursor-pointer rounded-md bg-gradient-to-r from-primary to-gradient-blue px-4 py-2 text-sm font-medium leading-6 text-white focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2'
                type='submit'
              >
                Apply for this job
              </Button>
            </Link>
          </div>

          <OverlaySpinner
            absolute
            visible={asyncStatus && asyncStatus[SendResume.type] === 'request'}
          />
        </div>
      </div>
    </div>
  )
}

export default PostBody
